import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../components/tables/ReportsTable';

const ReportsCommission = () => {
  const generateSampleData = (count = 50) => {
    const serviceTypes = ['Recharge', 'Bill Payment', 'DMT', 'AEPS', 'BBPS', 'Payout'];
    const statuses = ['Submitted', 'Pending', 'Approved'];

    return Array.from({ length: count }, (_, index) => {
      const amount = Math.random() * 8500 + 1500;
      const baseRate = parseFloat((Math.random() * 2.5 + 0.75).toFixed(2));
      const serviceCharge = parseFloat((amount * 0.015).toFixed(2));
      const distributorCommission = parseFloat((amount * baseRate / 100).toFixed(2));
      const distributorTds = parseFloat((distributorCommission * 0.05).toFixed(2));
      const netCommission = parseFloat((distributorCommission - distributorTds).toFixed(2));
      const retailerCommission = parseFloat((amount * 0.0125).toFixed(2));

      return {
        id: `SDC${String(index + 1).padStart(6, '0')}`,
        date: new Date(2025, Math.floor(Math.random() * 10), Math.floor(Math.random() * 28) + 1)
          .toISOString()
          .split('T')[0],
        distributor_code: `DIS${String(Math.floor(Math.random() * 9000) + 1000)}`,
        distributor_name: `Distributor ${Math.floor(Math.random() * 120) + 1}`,
        retailer_code: `RET${String(Math.floor(Math.random() * 9000) + 1000)}`,
        retailer_name: `Retailer ${Math.floor(Math.random() * 400) + 1}`,
        service: serviceTypes[Math.floor(Math.random() * serviceTypes.length)],
        amount: amount.toFixed(2),
        baseRate: `${baseRate.toFixed(2)}%`,
        serviceCharge: serviceCharge.toFixed(2),
        distributorCommission: distributorCommission.toFixed(2),
        distributorTds: distributorTds.toFixed(2),
        netCommission: netCommission.toFixed(2),
        retailerCommission: retailerCommission.toFixed(2),
        status: statuses[Math.floor(Math.random() * statuses.length)],
      };
    });
  };

  const [data] = useState(generateSampleData(70));

  const columns = [
    { key: 'id', label: 'Txn ID' },
    { key: 'date', label: 'Date' },
    { key: 'distributor_code', label: 'Distributor Code' },
    { key: 'distributor_name', label: 'Distributor Name' },
    { key: 'retailer_code', label: 'Retailer Code' },
    { key: 'retailer_name', label: 'Retailer Name' },
    { key: 'service', label: 'Service' },
    { key: 'amount', label: 'Amount' },
    { key: 'baseRate', label: 'Base Rate' },
    { key: 'serviceCharge', label: 'Service Charge' },
    { key: 'distributorCommission', label: 'Dist Commission' },
    { key: 'distributorTds', label: 'Dist TDS' },
    { key: 'netCommission', label: 'Net Commission' },
    { key: 'retailerCommission', label: 'Retailer Commission' },
    { key: 'status', label: 'Status' },
  ];

  return (
    <Container fluid>
      <ReportsTable
        data={data}
        reportType="SuperDistributor_Commission"
        columns={columns}
        title="Commission Reports"
      />
    </Container>
  );
};

export default ReportsCommission;

